module.exports = __webpack_public_path__ + "img/严重霾.f4c5cab3.png";